customElements.get("back-in-stock") ||
  customElements.define(
    "back-in-stock",
    class extends HTMLElement {
      constructor() {
        super();

        this.automaticSend = this.getAttribute("data-automatic-send") === "true";

        this.buttonCallToActionModal = this.querySelector(".back-in-stock__btn");
        this.buttonCloseModal = this.querySelector(".close-back-in-stock");
        this.backgroundOpacity = this.querySelector(".box-opacity");
        this.modalForm = this.querySelector("#modal-back-in-stock");
        this.formBackInStock = this.querySelector("#formBackInStock");
        this.messageError = this.querySelector(".message_error_field");
        this.titleProduct = this.querySelector(".back-in-stock__title-product");
        this.variantProduct = this.querySelector(".back-in-stock__variant-product");
        this.btnSend = this.querySelector(".modal-back-in-stock-btn");
        this.message_callback = this.querySelector(".message_callback");

        this.fieldEmail = this.querySelector('[name="backInStock_email"]');
        this.fieldPhone = this.querySelector('[name="backInStock_phone"]') ?? false;
        this.emailCheckbox = this.querySelector('[name="backInStock_check_email"]');
        this.whatsappCheckbox = this.querySelector('[name="backInStock_check_whatsapp"]') ?? false;
        this.inputVariant = this.querySelector("[name='backInStock_item-variant']");

        if(this.buttonCallToActionModal) this.buttonCallToActionModal.addEventListener("click", this._openPopUp.bind(this));
        if(this.buttonCloseModal) this.buttonCloseModal.addEventListener("click", this._closePopUp.bind(this));
        if(this.backgroundOpacity) this.backgroundOpacity.addEventListener("click", this._closePopUp.bind(this));
        this.fieldPhone ? this.fieldPhone.addEventListener("input", this._handlePhone.bind(this)) : null;

        if(this.formBackInStock) this.formBackInStock.addEventListener("submit", this._submit.bind(this));
      }

      _submit(e) {
        e.preventDefault();
        try {
          if (this._validate()) {
            this._sendForm();
          }
        } catch (error) {
          console.error(error);
        }
      }

      _sendForm() {
        this.btnSend.disabled = true;
        const data = {
          email: this.fieldEmail.value,
          phone: this.fieldPhone ? this.fieldPhone.value : false,
          variant: parseInt(this.inputVariant.value),
          notify_on_whatsapp: this.whatsappCheckbox ? this.whatsappCheckbox.checked : false,
          notify_on_sms: false,
          notify_on_email: this.emailCheckbox.checked,
          automatic_send: this.automaticSend,
        };

        fetch(`https://back-in-stock-backend-prod-b3c5b0b315ec.herokuapp.com/api/notifications/bis`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((response) => {
            this._messageCallback(response.success);
          });
      }

      _messageCallback(messageSuccess = true) {
        const btnSendBackInStock = this.btnSend;
        const messageElement = this.message_callback;

        messageElement.classList.add("active");

        if (messageSuccess) {
          messageElement.classList.add("success");
          this.fieldEmail.value = "";
          this.fieldPhone ? (this.fieldPhone.value = "") : null;
          setTimeout(() => {
            this._closePopUp();
          }, 2000);
        } else {
          messageElement.classList.add("error");
        }

        setTimeout(() => {
          btnSendBackInStock.disabled = false;
          messageElement.classList.remove("active");

          setTimeout(() => {
            messageElement.classList.remove("success", "error");
          }, 600);
        }, 5000);
      }

      _validate() {
        this._clearErrorMessage();
        const emailValue = this.fieldEmail.value.trim();
        const phoneValue = this.fieldPhone ? this.fieldPhone.value.trim() : true;

        if (!emailValue) {
          this._showErrorMessage(this.getAttribute("data-message-required-email"), "email");
          return false;
        } else if (emailValue) {
          if (!this._validateEmail(emailValue)) {
            this._showErrorMessage(this.getAttribute("data-message-invalid-email"), "email");
            return false;
          }
        } else if (phoneValue) {
          if (this.fieldPhone && !this._validatePhone(phoneValue)) {
            this._showErrorMessage(this.getAttribute("data-message-invalid-phone"), "phone");
            return false;
          }
        }

        if (this.emailCheckbox.checked && !emailValue) {
          this._showErrorMessage(this.getAttribute("data-message-required-email"), "email");
          return false;
        }

        if (this.whatsappCheckbox && this.whatsappCheckbox.checked) {
          if (!phoneValue) {
            this._showErrorMessage(this.getAttribute("data-message-required-phone"), "phone");
            return false;
          }
        }

        this._clearErrorMessage();
        return true;
      }

      _validateEmail(email) {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
      }

      _validatePhone(phone) {
        return phone.replace(/\D/g, "").length === 11;
      }

      _showErrorMessage(message, type = false) {
        let field = this.fieldPhone ? this.fieldPhone : false;
        if (type == "email") field = this.fieldEmail;
        if (field) {
          if (type) field.style.borderColor = "#ff6767";
          this.messageError.innerHTML = `<p>${message}</p>`;
        }
      }

      _clearErrorMessage() {
        this.fieldEmail.style.borderColor = "#ddd";
        this.fieldPhone ? (this.fieldPhone.style.borderColor = "#ddd") : false;
        this.messageError.innerHTML = "";
      }

      _handlePhone(event) {
        const input = event.target;
        input.value = this._phoneMask(input.value);
      }

      _phoneMask(value) {
        if (!value) return "";
        value = value.replace(/\D/g, "");
        value = value.replace(/(\d{2})(\d)/, "($1) $2");
        value = value.replace(/(\d)(\d{4})$/, "$1-$2");
        return value;
      }

      _setVariants() {
        const productInfoParent = this.closest("product-info");
        const nameProduct = productInfoParent.querySelector(".product__title h1").innerHTML;
        const variantRadios = productInfoParent.querySelector("variant-radios");

        const fieldsets = Array.from(variantRadios.querySelectorAll("fieldset"));
        const valuesVariant = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked)?.value;
        });

        if (valuesVariant.includes(undefined)) {
          const product_info = this.closest("product-info");
          const product_form = product_info.querySelector("product-form");
          product_form.handleErrorMessage("Selecione um tamanho!");
          return false;
        }

        this.titleProduct.innerHTML = nameProduct;
        this.variantProduct.innerHTML = valuesVariant.join("/");

        const productForm = productInfoParent.querySelector("product-form");
        const idVariant = productForm.querySelector("input[name='id']").value;

        this.inputVariant.value = idVariant;
        return true;
      }

      _openPopUp() {
        if (!this._setVariants()) return;
        this.modalForm.style.display = "flex";
        setTimeout(() => {
          this.modalForm.style.opacity = "1.0";
        }, 0);
      }

      _closePopUp() {
        this.modalForm.style.opacity = "0.0";
        this._clearErrorMessage();
        setTimeout(() => {
          this.modalForm.style.display = "none";
        }, 700);
      }
    },
  );
